export default "__VITE_ASSET__V15bVKQW__"